import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TopBar } from "./components/sections/TopBar";
import { Header } from "./components/sections/Header";
import { Hero } from "./components/sections/Hero";
import { Services } from "./components/sections/Services";
import { Testimonials } from "./components/sections/Testimonials";
import { Quote } from "./components/sections/Quote";
import { FAQ } from "./components/sections/FAQ";
import { Footer } from "./components/sections/Footer";
import { FloatingWhatsApp } from "./components/sections/FloatingWhatsApp";
import { ScrollProgress } from "./components/ScrollProgress";
import { SideActions } from "./components/SideActions";
import { CookieBanner } from "./components/CookieBanner";
import { QuoteNudge } from "./components/QuoteNudge";

const Home = () => {
  return (
    <div className="font-body bg-white">
      <ScrollProgress />
      <SideActions />
      <TopBar />
      <Header />
      <main>
        <Hero />
        <Services />
        <Testimonials />
        <Quote />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <CookieBanner />
      <QuoteNudge />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
